module.exports = __webpack_public_path__ + "static/fipctransportmain-9187616524216ba097a7e3ebf7557087.jpeg";